"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSecondaryInfoComponent = exports.buildHelpOtpComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const translations_1 = require("../../translations");
const features_1 = require("../../features");
const buildHelpOtpComponent = (channel, componentConfig) => {
    const { Link, Phone, onClickLink } = componentConfig;
    const text = features_1.AuthoriserLiterals.HELP_OTP[channel];
    const helpComponent = (0, translations_1.translateToComponent)(text.DESCRIPTION, {
        link: (0, jsx_runtime_1.jsx)(Link, { onClickLink: onClickLink, renderText: () => (0, translations_1.translate)(text.LINK) }),
        telephoneNo: (0, jsx_runtime_1.jsx)(Phone, { renderText: () => (0, translations_1.translate)(text.PHONE) }),
    });
    return helpComponent;
};
exports.buildHelpOtpComponent = buildHelpOtpComponent;
const buildSecondaryInfoComponent = (componentConfig) => {
    const { Link, onClickLink } = componentConfig;
    const secondaryInfoComponent = (0, translations_1.translateToComponent)(features_1.AuthoriserLiterals.TRUSTED_MESSAGE_ERROR_DESCRIPTION, {
        link: (0, jsx_runtime_1.jsx)(Link, { onClickLink: onClickLink, renderText: () => (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_MESSAGE_SECOND_ERROR_LINK) }),
    });
    return secondaryInfoComponent;
};
exports.buildSecondaryInfoComponent = buildSecondaryInfoComponent;
//# sourceMappingURL=translatedComponents.js.map